'use client';

import { clsx } from 'clsx';
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { FC } from 'react';

import { FlexibleSection } from '../flexibleContent.type';
import { getSectionClasses } from '../getSectionClasses.helper';

interface Props extends FlexibleSection {
  sectionData: {
    formId: string;
  };
}

const IframeResizer = dynamic(() => import('@open-iframe-resizer/react').then((mod) => mod.IframeResizer), {
  ssr: false,
});

export const ActiveCampaignFormSection: FC<Props> = ({ sectionData, sectionBackground }: Props) => {
  const { formId } = sectionData;
  const pathname = usePathname();

  const partnershipsPage = pathname === '/partnerships';

  return (
    <section className={clsx(getSectionClasses(sectionBackground))}>
      <IframeResizer src={`/active-campaign/${formId}`} style={{ border: 'none', width: '100%' }} />

      {/* Legals */}
      {partnershipsPage && (
        <div className="mx-auto mt-6 mb-6 flex max-w-lg flex-col gap-1 text-center">
          <div className="c-fs-caption text-tex-def-tie3">
            View our{' '}
            <a href="/privacy-collection-notice" target="_blank">
              Privacy Collection Notice
            </a>{' '}
            to understand how we use your personal information.
          </div>
        </div>
      )}
    </section>
  );
};
